import React from 'react';
import ReactDOM from 'react-dom';
import styles from './Modal.module.css';

export function Modal({ isOpen, onClose, children, wide = false }) {
	if (!isOpen) {
		return null;
	}

	return ReactDOM.createPortal(
		<div className={styles.overlay} onClick={onClose}>
			<div
				className={`${styles.modal} ${wide ? styles.modalWide : ''}`}
				onClick={(e) => e.stopPropagation()}
			>
				<button className={styles.closeBtn} onClick={onClose}>
          			&times;
				</button>
				{children}
			</div>
		</div>,
		document.body
	);
}
